/* eslint-disable no-useless-concat */
export const compact = (x: number) => compactShort(x, 0)

export const compactSmall = (x?: number | string | null) => {
  if (!x && isNaN(x as number)) {
    return ""
  } else {
    return compactShort(x as number, 2)
  }
}
export const compactRoundSmall = (x?: number | string | null) => {
  if (!x && isNaN(x as number)) {
    return ""
  } else {
    return compactShort(x as number, 1)
  }
}
export const compactLarge = (x: number) => compactShort(x, 3)

export const compactShort = (x: number, digits?: number) =>
  CompactShort(digits).format(x)
const CompactShort = (digits?: number) =>
  new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })

export const compactThousandsSeparated = (x: number) => {
  return CompactShortThousandsSeparated.format(x)
}
const CompactShortThousandsSeparated = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
})

/*
  Currencies formatters
*/

export function percentanceFormat(
  data?: number | null,
  hasArrowIcon?: boolean,
) {
  let result = ""
  if (!data && data !== 0) {
    return (result = "N/A")
  }
  if (data === 0) {
    return (result = "0.00%")
  }
  if (hasArrowIcon) {
    return (result =
      (Number(data) < 0 ? "\u25BC" : "\u25B2") + " " + compactSmall(data) + "%")
  }
  result = compactSmall(data) + "%"
  return result
}

export function netFormat(data?: number | null, hasArrowIcon?: boolean) {
  let result = ""
  if (!data && data !== 0) {
    return (result = "N/A")
  }
  if (data === 0) {
    return (result = "$ 0.00")
  }
  if (hasArrowIcon) {
    return (result =
      (Number(data) < 0 ? "\u25BC" : "\u25B2") + " " + "$" + compactSmall(data))
  }
  result = "$" + compactSmall(data)
  return result
}
